/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateIntegrationRepositoriesRequestIntegrationRepositories } from '../models';
// @ts-ignore
import type { CreateIntegrationRequestIntegration } from '../models';
// @ts-ignore
import type { CreateRepositoryDiscoveryRequestRepositoryDiscovery } from '../models';
// @ts-ignore
import type { Integration } from '../models';
// @ts-ignore
import type { IntegrationRepositories } from '../models';
// @ts-ignore
import type { ListIntegrationRepositoriesResponse } from '../models';
// @ts-ignore
import type { ListIntegrationsOrganizationResponse } from '../models';
// @ts-ignore
import type { ListOrganizationRepositoriesResponse } from '../models';
// @ts-ignore
import type { ListRepositoryDiscoveriesResponse } from '../models';
// @ts-ignore
import type { RecordScanSkipRequest } from '../models';
// @ts-ignore
import type { RepositoryDiscovery } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { SyncIntegrationRepositoriesRequest } from '../models';
// @ts-ignore
import type { SyncIntegrationRepositoriesResponse } from '../models';
// @ts-ignore
import type { UpdateIntegrationRequest } from '../models';
// @ts-ignore
import type { UpdateRepositoriesRequest } from '../models';
// @ts-ignore
import type { UpdateRepositoriesResponse } from '../models';
// @ts-ignore
import type { UpdateRepositoryDiscoveryRequestRepositoryDiscovery } from '../models';
/**
 * IntegrationsAPIApi - axios parameter creator
 * @export
 */
export const IntegrationsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds integration to a runbook.
         * @summary Add an integration to a runbook.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIAddIntegrationToRunbook: async (organizationId: string, runbookIntegrationId: string, runbookId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIAddIntegrationToRunbook', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPIAddIntegrationToRunbook', 'runbookIntegrationId', runbookIntegrationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/addToRunbook`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runbookId !== undefined) {
                localVarQueryParameter['runbookId'] = runbookId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new integration for an organization.
         * @summary Create a new integration.
         * @param {string} integrationOrganizationId 
         * @param {CreateIntegrationRequestIntegration} createIntegrationRequestIntegration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateIntegration: async (integrationOrganizationId: string, createIntegrationRequestIntegration: CreateIntegrationRequestIntegration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationOrganizationId' is not null or undefined
            assertParamExists('integrationsAPICreateIntegration', 'integrationOrganizationId', integrationOrganizationId)
            // verify required parameter 'createIntegrationRequestIntegration' is not null or undefined
            assertParamExists('integrationsAPICreateIntegration', 'createIntegrationRequestIntegration', createIntegrationRequestIntegration)
            const localVarPath = `/application-automation/v1alpha/organizations/{integration.organization_id}/runbook-integrations`
                .replace(`{${"integration.organization_id"}}`, encodeURIComponent(String(integrationOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntegrationRequestIntegration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new repositories for an integration.  Deprecated: Use SyncIntegrationRepositories instead.
         * @summary Create new repositories for an integration.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {CreateIntegrationRepositoriesRequestIntegrationRepositories} createIntegrationRepositoriesRequestIntegrationRepositories 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateIntegrationRepositories: async (organizationId: string, runbookIntegrationId: string, createIntegrationRepositoriesRequestIntegrationRepositories: CreateIntegrationRepositoriesRequestIntegrationRepositories, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPICreateIntegrationRepositories', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPICreateIntegrationRepositories', 'runbookIntegrationId', runbookIntegrationId)
            // verify required parameter 'createIntegrationRepositoriesRequestIntegrationRepositories' is not null or undefined
            assertParamExists('integrationsAPICreateIntegrationRepositories', 'createIntegrationRepositoriesRequestIntegrationRepositories', createIntegrationRepositoriesRequestIntegrationRepositories)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/repositories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIntegrationRepositoriesRequestIntegrationRepositories, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create discovery results for a repository.
         * @summary Create discovery results for a repository.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId Deprecated: The ID of the repository
         * @param {CreateRepositoryDiscoveryRequestRepositoryDiscovery} createRepositoryDiscoveryRequestRepositoryDiscovery 
         * @param {string} [orgRepositoryId] The stable repository ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateRepositoryDiscovery: async (organizationId: string, runbookIntegrationId: string, repositoryId: string, createRepositoryDiscoveryRequestRepositoryDiscovery: CreateRepositoryDiscoveryRequestRepositoryDiscovery, orgRepositoryId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPICreateRepositoryDiscovery', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPICreateRepositoryDiscovery', 'runbookIntegrationId', runbookIntegrationId)
            // verify required parameter 'repositoryId' is not null or undefined
            assertParamExists('integrationsAPICreateRepositoryDiscovery', 'repositoryId', repositoryId)
            // verify required parameter 'createRepositoryDiscoveryRequestRepositoryDiscovery' is not null or undefined
            assertParamExists('integrationsAPICreateRepositoryDiscovery', 'createRepositoryDiscoveryRequestRepositoryDiscovery', createRepositoryDiscoveryRequestRepositoryDiscovery)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/repositories/{repositoryId}/discovery`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)))
                .replace(`{${"repositoryId"}}`, encodeURIComponent(String(repositoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgRepositoryId !== undefined) {
                localVarQueryParameter['orgRepositoryId'] = orgRepositoryId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepositoryDiscoveryRequestRepositoryDiscovery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes integration from a runbook.
         * @summary Deletes integration from a runbook.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIDeleteIntegrationFromRunbook: async (organizationId: string, runbookIntegrationId: string, runbookId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIDeleteIntegrationFromRunbook', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPIDeleteIntegrationFromRunbook', 'runbookIntegrationId', runbookIntegrationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/deleteFromRunbook`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runbookId !== undefined) {
                localVarQueryParameter['runbookId'] = runbookId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization-scoped integration by ID.
         * @summary Delete organization-scoped integration by ID.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} id The ID of the integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIDeleteIntegrationOrganization: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIDeleteIntegrationOrganization', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('integrationsAPIDeleteIntegrationOrganization', 'id', id)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organization-scoped integration by ID.
         * @summary Get organization-scoped integration by ID.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} id The ID of the integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIGetIntegrationOrganization: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIGetIntegrationOrganization', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('integrationsAPIGetIntegrationOrganization', 'id', id)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List integration repositories.
         * @summary List integration repositories.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [includeDisabled] Include repositories with discovery disabled. By default only enabled repos are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListIntegrationRepositories: async (organizationId: string, runbookIntegrationId: string, pageLimit?: string, pageCursor?: string, includeDisabled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIListIntegrationRepositories', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPIListIntegrationRepositories', 'runbookIntegrationId', runbookIntegrationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/repositories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (includeDisabled !== undefined) {
                localVarQueryParameter['includeDisabled'] = includeDisabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List integrations for runbooks for a particular organization.
         * @summary List integrations for runbooks.
         * @param {string} organizationId The ID of the organization.
         * @param {boolean} [includeClusterIntegrations] Should the response include cluster-scoped integrations?
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListIntegrationsOrganization: async (organizationId: string, includeClusterIntegrations?: boolean, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIListIntegrationsOrganization', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeClusterIntegrations !== undefined) {
                localVarQueryParameter['includeClusterIntegrations'] = includeClusterIntegrations;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all repositories for an organization
         * @summary List all repositories for an organization.
         * @param {string} organizationId The organization ID.
         * @param {Array<string>} [integrationIds] Filter by integration IDs.
         * @param {boolean} [includeDiscovery] Include discovery data in the response.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListOrganizationRepositories: async (organizationId: string, integrationIds?: Array<string>, includeDiscovery?: boolean, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIListOrganizationRepositories', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/repositories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationIds) {
                localVarQueryParameter['integrationIds'] = integrationIds;
            }

            if (includeDiscovery !== undefined) {
                localVarQueryParameter['includeDiscovery'] = includeDiscovery;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List repository discoveries with filtering.
         * @summary List repository discoveries with filtering.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {Array<string>} [integrationIds] Filter by integration IDs.
         * @param {Array<string>} [repositoryIds] Filter by repository IDs.
         * @param {Array<string>} [workloadFilterNames] Filter by workload names.
         * @param {Array<string>} [workloadFilterNamespaces] Filter by Kubernetes namespaces.
         * @param {Array<string>} [workloadFilterKinds] Filter by Kubernetes resource kinds (Deployment, StatefulSet, etc.)
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListRepositoryDiscoveries: async (organizationId: string, integrationIds?: Array<string>, repositoryIds?: Array<string>, workloadFilterNames?: Array<string>, workloadFilterNamespaces?: Array<string>, workloadFilterKinds?: Array<string>, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIListRepositoryDiscoveries', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/repository-discoveries`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationIds) {
                localVarQueryParameter['integrationIds'] = integrationIds;
            }

            if (repositoryIds) {
                localVarQueryParameter['repositoryIds'] = repositoryIds;
            }

            if (workloadFilterNames) {
                localVarQueryParameter['workloadFilter.names'] = workloadFilterNames;
            }

            if (workloadFilterNamespaces) {
                localVarQueryParameter['workloadFilter.namespaces'] = workloadFilterNamespaces;
            }

            if (workloadFilterKinds) {
                localVarQueryParameter['workloadFilter.kinds'] = workloadFilterKinds;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record that a repository scan was skipped due to no changes.
         * @summary Record that a repository scan was skipped due to no changes.
         * @param {string} organizationId The organization ID.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId The ID of the repository.
         * @param {RecordScanSkipRequest} recordScanSkipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIRecordScanSkip: async (organizationId: string, runbookIntegrationId: string, repositoryId: string, recordScanSkipRequest: RecordScanSkipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIRecordScanSkip', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPIRecordScanSkip', 'runbookIntegrationId', runbookIntegrationId)
            // verify required parameter 'repositoryId' is not null or undefined
            assertParamExists('integrationsAPIRecordScanSkip', 'repositoryId', repositoryId)
            // verify required parameter 'recordScanSkipRequest' is not null or undefined
            assertParamExists('integrationsAPIRecordScanSkip', 'recordScanSkipRequest', recordScanSkipRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/repositories/{repositoryId}/discoveries/skip`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)))
                .replace(`{${"repositoryId"}}`, encodeURIComponent(String(repositoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordScanSkipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync repositories for an integration
         * @summary Sync repositories for an integration.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {SyncIntegrationRepositoriesRequest} syncIntegrationRepositoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPISyncIntegrationRepositories: async (organizationId: string, runbookIntegrationId: string, syncIntegrationRepositoriesRequest: SyncIntegrationRepositoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPISyncIntegrationRepositories', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPISyncIntegrationRepositories', 'runbookIntegrationId', runbookIntegrationId)
            // verify required parameter 'syncIntegrationRepositoriesRequest' is not null or undefined
            assertParamExists('integrationsAPISyncIntegrationRepositories', 'syncIntegrationRepositoriesRequest', syncIntegrationRepositoriesRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/sync-repositories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncIntegrationRepositoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateIntegration updates an integration\'s status fields.  Used by runbook operator to report integration health.
         * @summary Update an integration\'s status.
         * @param {string} organizationId Organization ID (required).
         * @param {string} id Integration ID to update (required).
         * @param {UpdateIntegrationRequest} updateIntegrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateIntegration: async (organizationId: string, id: string, updateIntegrationRequest: UpdateIntegrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIUpdateIntegration', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('integrationsAPIUpdateIntegration', 'id', id)
            // verify required parameter 'updateIntegrationRequest' is not null or undefined
            assertParamExists('integrationsAPIUpdateIntegration', 'updateIntegrationRequest', updateIntegrationRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIntegrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update repositories discovery settings in bulk.
         * @summary Update repositories discovery settings.
         * @param {string} organizationId The organization ID.
         * @param {UpdateRepositoriesRequest} updateRepositoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateRepositories: async (organizationId: string, updateRepositoriesRequest: UpdateRepositoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositories', 'organizationId', organizationId)
            // verify required parameter 'updateRepositoriesRequest' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositories', 'updateRepositoriesRequest', updateRepositoriesRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/repositories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepositoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing discovery results for a repository.
         * @summary Update discovery results for a repository.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId The ID of the repository.
         * @param {UpdateRepositoryDiscoveryRequestRepositoryDiscovery} updateRepositoryDiscoveryRequestRepositoryDiscovery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateRepositoryDiscovery: async (organizationId: string, runbookIntegrationId: string, repositoryId: string, updateRepositoryDiscoveryRequestRepositoryDiscovery: UpdateRepositoryDiscoveryRequestRepositoryDiscovery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositoryDiscovery', 'organizationId', organizationId)
            // verify required parameter 'runbookIntegrationId' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositoryDiscovery', 'runbookIntegrationId', runbookIntegrationId)
            // verify required parameter 'repositoryId' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositoryDiscovery', 'repositoryId', repositoryId)
            // verify required parameter 'updateRepositoryDiscoveryRequestRepositoryDiscovery' is not null or undefined
            assertParamExists('integrationsAPIUpdateRepositoryDiscovery', 'updateRepositoryDiscoveryRequestRepositoryDiscovery', updateRepositoryDiscoveryRequestRepositoryDiscovery)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-integrations/{runbookIntegrationId}/repositories/{repositoryId}/discovery`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"runbookIntegrationId"}}`, encodeURIComponent(String(runbookIntegrationId)))
                .replace(`{${"repositoryId"}}`, encodeURIComponent(String(repositoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepositoryDiscoveryRequestRepositoryDiscovery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationsAPIApi - functional programming interface
 * @export
 */
export const IntegrationsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds integration to a runbook.
         * @summary Add an integration to a runbook.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIAddIntegrationToRunbook(organizationId: string, runbookIntegrationId: string, runbookId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIAddIntegrationToRunbook(organizationId, runbookIntegrationId, runbookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIAddIntegrationToRunbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new integration for an organization.
         * @summary Create a new integration.
         * @param {string} integrationOrganizationId 
         * @param {CreateIntegrationRequestIntegration} createIntegrationRequestIntegration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPICreateIntegration(integrationOrganizationId: string, createIntegrationRequestIntegration: CreateIntegrationRequestIntegration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Integration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPICreateIntegration(integrationOrganizationId, createIntegrationRequestIntegration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPICreateIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create new repositories for an integration.  Deprecated: Use SyncIntegrationRepositories instead.
         * @summary Create new repositories for an integration.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {CreateIntegrationRepositoriesRequestIntegrationRepositories} createIntegrationRepositoriesRequestIntegrationRepositories 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPICreateIntegrationRepositories(organizationId: string, runbookIntegrationId: string, createIntegrationRepositoriesRequestIntegrationRepositories: CreateIntegrationRepositoriesRequestIntegrationRepositories, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationRepositories>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPICreateIntegrationRepositories(organizationId, runbookIntegrationId, createIntegrationRepositoriesRequestIntegrationRepositories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPICreateIntegrationRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create discovery results for a repository.
         * @summary Create discovery results for a repository.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId Deprecated: The ID of the repository
         * @param {CreateRepositoryDiscoveryRequestRepositoryDiscovery} createRepositoryDiscoveryRequestRepositoryDiscovery 
         * @param {string} [orgRepositoryId] The stable repository ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPICreateRepositoryDiscovery(organizationId: string, runbookIntegrationId: string, repositoryId: string, createRepositoryDiscoveryRequestRepositoryDiscovery: CreateRepositoryDiscoveryRequestRepositoryDiscovery, orgRepositoryId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepositoryDiscovery>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPICreateRepositoryDiscovery(organizationId, runbookIntegrationId, repositoryId, createRepositoryDiscoveryRequestRepositoryDiscovery, orgRepositoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPICreateRepositoryDiscovery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes integration from a runbook.
         * @summary Deletes integration from a runbook.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIDeleteIntegrationFromRunbook(organizationId: string, runbookIntegrationId: string, runbookId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIDeleteIntegrationFromRunbook(organizationId, runbookIntegrationId, runbookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIDeleteIntegrationFromRunbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization-scoped integration by ID.
         * @summary Delete organization-scoped integration by ID.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} id The ID of the integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIDeleteIntegrationOrganization(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIDeleteIntegrationOrganization(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIDeleteIntegrationOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get organization-scoped integration by ID.
         * @summary Get organization-scoped integration by ID.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} id The ID of the integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIGetIntegrationOrganization(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Integration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIGetIntegrationOrganization(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIGetIntegrationOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List integration repositories.
         * @summary List integration repositories.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [includeDisabled] Include repositories with discovery disabled. By default only enabled repos are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIListIntegrationRepositories(organizationId: string, runbookIntegrationId: string, pageLimit?: string, pageCursor?: string, includeDisabled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListIntegrationRepositoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIListIntegrationRepositories(organizationId, runbookIntegrationId, pageLimit, pageCursor, includeDisabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIListIntegrationRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List integrations for runbooks for a particular organization.
         * @summary List integrations for runbooks.
         * @param {string} organizationId The ID of the organization.
         * @param {boolean} [includeClusterIntegrations] Should the response include cluster-scoped integrations?
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIListIntegrationsOrganization(organizationId: string, includeClusterIntegrations?: boolean, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListIntegrationsOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIListIntegrationsOrganization(organizationId, includeClusterIntegrations, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIListIntegrationsOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all repositories for an organization
         * @summary List all repositories for an organization.
         * @param {string} organizationId The organization ID.
         * @param {Array<string>} [integrationIds] Filter by integration IDs.
         * @param {boolean} [includeDiscovery] Include discovery data in the response.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIListOrganizationRepositories(organizationId: string, integrationIds?: Array<string>, includeDiscovery?: boolean, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOrganizationRepositoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIListOrganizationRepositories(organizationId, integrationIds, includeDiscovery, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIListOrganizationRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List repository discoveries with filtering.
         * @summary List repository discoveries with filtering.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {Array<string>} [integrationIds] Filter by integration IDs.
         * @param {Array<string>} [repositoryIds] Filter by repository IDs.
         * @param {Array<string>} [workloadFilterNames] Filter by workload names.
         * @param {Array<string>} [workloadFilterNamespaces] Filter by Kubernetes namespaces.
         * @param {Array<string>} [workloadFilterKinds] Filter by Kubernetes resource kinds (Deployment, StatefulSet, etc.)
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIListRepositoryDiscoveries(organizationId: string, integrationIds?: Array<string>, repositoryIds?: Array<string>, workloadFilterNames?: Array<string>, workloadFilterNamespaces?: Array<string>, workloadFilterKinds?: Array<string>, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRepositoryDiscoveriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIListRepositoryDiscoveries(organizationId, integrationIds, repositoryIds, workloadFilterNames, workloadFilterNamespaces, workloadFilterKinds, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIListRepositoryDiscoveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Record that a repository scan was skipped due to no changes.
         * @summary Record that a repository scan was skipped due to no changes.
         * @param {string} organizationId The organization ID.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId The ID of the repository.
         * @param {RecordScanSkipRequest} recordScanSkipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIRecordScanSkip(organizationId: string, runbookIntegrationId: string, repositoryId: string, recordScanSkipRequest: RecordScanSkipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIRecordScanSkip(organizationId, runbookIntegrationId, repositoryId, recordScanSkipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIRecordScanSkip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync repositories for an integration
         * @summary Sync repositories for an integration.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {SyncIntegrationRepositoriesRequest} syncIntegrationRepositoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPISyncIntegrationRepositories(organizationId: string, runbookIntegrationId: string, syncIntegrationRepositoriesRequest: SyncIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncIntegrationRepositoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPISyncIntegrationRepositories(organizationId, runbookIntegrationId, syncIntegrationRepositoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPISyncIntegrationRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * UpdateIntegration updates an integration\'s status fields.  Used by runbook operator to report integration health.
         * @summary Update an integration\'s status.
         * @param {string} organizationId Organization ID (required).
         * @param {string} id Integration ID to update (required).
         * @param {UpdateIntegrationRequest} updateIntegrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIUpdateIntegration(organizationId: string, id: string, updateIntegrationRequest: UpdateIntegrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Integration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIUpdateIntegration(organizationId, id, updateIntegrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIUpdateIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update repositories discovery settings in bulk.
         * @summary Update repositories discovery settings.
         * @param {string} organizationId The organization ID.
         * @param {UpdateRepositoriesRequest} updateRepositoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIUpdateRepositories(organizationId: string, updateRepositoriesRequest: UpdateRepositoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateRepositoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIUpdateRepositories(organizationId, updateRepositoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIUpdateRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update existing discovery results for a repository.
         * @summary Update discovery results for a repository.
         * @param {string} organizationId The organization ID to which the integration belongs.
         * @param {string} runbookIntegrationId The ID of the integration.
         * @param {string} repositoryId The ID of the repository.
         * @param {UpdateRepositoryDiscoveryRequestRepositoryDiscovery} updateRepositoryDiscoveryRequestRepositoryDiscovery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationsAPIUpdateRepositoryDiscovery(organizationId: string, runbookIntegrationId: string, repositoryId: string, updateRepositoryDiscoveryRequestRepositoryDiscovery: UpdateRepositoryDiscoveryRequestRepositoryDiscovery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepositoryDiscovery>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationsAPIUpdateRepositoryDiscovery(organizationId, runbookIntegrationId, repositoryId, updateRepositoryDiscoveryRequestRepositoryDiscovery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsAPIApi.integrationsAPIUpdateRepositoryDiscovery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationsAPIApi - factory interface
 * @export
 */
export const IntegrationsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationsAPIApiFp(configuration)
    return {
        /**
         * Adds integration to a runbook.
         * @summary Add an integration to a runbook.
         * @param {IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIAddIntegrationToRunbook(requestParameters: IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.integrationsAPIAddIntegrationToRunbook(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.runbookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new integration for an organization.
         * @summary Create a new integration.
         * @param {IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateIntegration(requestParameters: IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Integration> {
            return localVarFp.integrationsAPICreateIntegration(requestParameters.integrationOrganizationId, requestParameters.createIntegrationRequestIntegration, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new repositories for an integration.  Deprecated: Use SyncIntegrationRepositories instead.
         * @summary Create new repositories for an integration.
         * @param {IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationRepositories> {
            return localVarFp.integrationsAPICreateIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.createIntegrationRepositoriesRequestIntegrationRepositories, options).then((request) => request(axios, basePath));
        },
        /**
         * Create discovery results for a repository.
         * @summary Create discovery results for a repository.
         * @param {IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPICreateRepositoryDiscovery(requestParameters: IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepositoryDiscovery> {
            return localVarFp.integrationsAPICreateRepositoryDiscovery(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.createRepositoryDiscoveryRequestRepositoryDiscovery, requestParameters.orgRepositoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes integration from a runbook.
         * @summary Deletes integration from a runbook.
         * @param {IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIDeleteIntegrationFromRunbook(requestParameters: IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.integrationsAPIDeleteIntegrationFromRunbook(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.runbookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization-scoped integration by ID.
         * @summary Delete organization-scoped integration by ID.
         * @param {IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIDeleteIntegrationOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.integrationsAPIDeleteIntegrationOrganization(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get organization-scoped integration by ID.
         * @summary Get organization-scoped integration by ID.
         * @param {IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIGetIntegrationOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Integration> {
            return localVarFp.integrationsAPIGetIntegrationOrganization(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List integration repositories.
         * @summary List integration repositories.
         * @param {IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListIntegrationRepositoriesResponse> {
            return localVarFp.integrationsAPIListIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.includeDisabled, options).then((request) => request(axios, basePath));
        },
        /**
         * List integrations for runbooks for a particular organization.
         * @summary List integrations for runbooks.
         * @param {IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListIntegrationsOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListIntegrationsOrganizationResponse> {
            return localVarFp.integrationsAPIListIntegrationsOrganization(requestParameters.organizationId, requestParameters.includeClusterIntegrations, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List all repositories for an organization
         * @summary List all repositories for an organization.
         * @param {IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListOrganizationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListOrganizationRepositoriesResponse> {
            return localVarFp.integrationsAPIListOrganizationRepositories(requestParameters.organizationId, requestParameters.integrationIds, requestParameters.includeDiscovery, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List repository discoveries with filtering.
         * @summary List repository discoveries with filtering.
         * @param {IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIListRepositoryDiscoveries(requestParameters: IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRepositoryDiscoveriesResponse> {
            return localVarFp.integrationsAPIListRepositoryDiscoveries(requestParameters.organizationId, requestParameters.integrationIds, requestParameters.repositoryIds, requestParameters.workloadFilterNames, requestParameters.workloadFilterNamespaces, requestParameters.workloadFilterKinds, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Record that a repository scan was skipped due to no changes.
         * @summary Record that a repository scan was skipped due to no changes.
         * @param {IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIRecordScanSkip(requestParameters: IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.integrationsAPIRecordScanSkip(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.recordScanSkipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync repositories for an integration
         * @summary Sync repositories for an integration.
         * @param {IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPISyncIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncIntegrationRepositoriesResponse> {
            return localVarFp.integrationsAPISyncIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.syncIntegrationRepositoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateIntegration updates an integration\'s status fields.  Used by runbook operator to report integration health.
         * @summary Update an integration\'s status.
         * @param {IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateIntegration(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Integration> {
            return localVarFp.integrationsAPIUpdateIntegration(requestParameters.organizationId, requestParameters.id, requestParameters.updateIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update repositories discovery settings in bulk.
         * @summary Update repositories discovery settings.
         * @param {IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateRepositoriesResponse> {
            return localVarFp.integrationsAPIUpdateRepositories(requestParameters.organizationId, requestParameters.updateRepositoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update existing discovery results for a repository.
         * @summary Update discovery results for a repository.
         * @param {IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsAPIUpdateRepositoryDiscovery(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepositoryDiscovery> {
            return localVarFp.integrationsAPIUpdateRepositoryDiscovery(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.updateRepositoryDiscoveryRequestRepositoryDiscovery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for integrationsAPIAddIntegrationToRunbook operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbook
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbook
     */
    readonly runbookIntegrationId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbook
     */
    readonly runbookId?: string
}

/**
 * Request parameters for integrationsAPICreateIntegration operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest
 */
export interface IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateIntegration
     */
    readonly integrationOrganizationId: string

    /**
     * 
     * @type {CreateIntegrationRequestIntegration}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateIntegration
     */
    readonly createIntegrationRequestIntegration: CreateIntegrationRequestIntegration
}

/**
 * Request parameters for integrationsAPICreateIntegrationRepositories operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositories
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositories
     */
    readonly runbookIntegrationId: string

    /**
     * 
     * @type {CreateIntegrationRepositoriesRequestIntegrationRepositories}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositories
     */
    readonly createIntegrationRepositoriesRequestIntegrationRepositories: CreateIntegrationRepositoriesRequestIntegrationRepositories
}

/**
 * Request parameters for integrationsAPICreateRepositoryDiscovery operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest
 */
export interface IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscovery
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscovery
     */
    readonly runbookIntegrationId: string

    /**
     * Deprecated: The ID of the repository
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscovery
     */
    readonly repositoryId: string

    /**
     * 
     * @type {CreateRepositoryDiscoveryRequestRepositoryDiscovery}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscovery
     */
    readonly createRepositoryDiscoveryRequestRepositoryDiscovery: CreateRepositoryDiscoveryRequestRepositoryDiscovery

    /**
     * The stable repository ID
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscovery
     */
    readonly orgRepositoryId?: string
}

/**
 * Request parameters for integrationsAPIDeleteIntegrationFromRunbook operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbook
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbook
     */
    readonly runbookIntegrationId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbook
     */
    readonly runbookId?: string
}

/**
 * Request parameters for integrationsAPIDeleteIntegrationOrganization operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganization
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganization
     */
    readonly id: string
}

/**
 * Request parameters for integrationsAPIGetIntegrationOrganization operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganization
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganization
     */
    readonly id: string
}

/**
 * Request parameters for integrationsAPIListIntegrationRepositories operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationRepositories
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationRepositories
     */
    readonly runbookIntegrationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationRepositories
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationRepositories
     */
    readonly pageCursor?: string

    /**
     * Include repositories with discovery disabled. By default only enabled repos are returned.
     * @type {boolean}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationRepositories
     */
    readonly includeDisabled?: boolean
}

/**
 * Request parameters for integrationsAPIListIntegrationsOrganization operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganization
     */
    readonly organizationId: string

    /**
     * Should the response include cluster-scoped integrations?
     * @type {boolean}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganization
     */
    readonly includeClusterIntegrations?: boolean

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganization
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganization
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for integrationsAPIListOrganizationRepositories operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListOrganizationRepositories
     */
    readonly organizationId: string

    /**
     * Filter by integration IDs.
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListOrganizationRepositories
     */
    readonly integrationIds?: Array<string>

    /**
     * Include discovery data in the response.
     * @type {boolean}
     * @memberof IntegrationsAPIApiIntegrationsAPIListOrganizationRepositories
     */
    readonly includeDiscovery?: boolean

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListOrganizationRepositories
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListOrganizationRepositories
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for integrationsAPIListRepositoryDiscoveries operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly organizationId: string

    /**
     * Filter by integration IDs.
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly integrationIds?: Array<string>

    /**
     * Filter by repository IDs.
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly repositoryIds?: Array<string>

    /**
     * Filter by workload names.
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly workloadFilterNames?: Array<string>

    /**
     * Filter by Kubernetes namespaces.
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly workloadFilterNamespaces?: Array<string>

    /**
     * Filter by Kubernetes resource kinds (Deployment, StatefulSet, etc.)
     * @type {Array<string>}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly workloadFilterKinds?: Array<string>

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveries
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for integrationsAPIRecordScanSkip operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIRecordScanSkip
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIRecordScanSkip
     */
    readonly runbookIntegrationId: string

    /**
     * The ID of the repository.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIRecordScanSkip
     */
    readonly repositoryId: string

    /**
     * 
     * @type {RecordScanSkipRequest}
     * @memberof IntegrationsAPIApiIntegrationsAPIRecordScanSkip
     */
    readonly recordScanSkipRequest: RecordScanSkipRequest
}

/**
 * Request parameters for integrationsAPISyncIntegrationRepositories operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositories
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositories
     */
    readonly runbookIntegrationId: string

    /**
     * 
     * @type {SyncIntegrationRepositoriesRequest}
     * @memberof IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositories
     */
    readonly syncIntegrationRepositoriesRequest: SyncIntegrationRepositoriesRequest
}

/**
 * Request parameters for integrationsAPIUpdateIntegration operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest {
    /**
     * Organization ID (required).
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateIntegration
     */
    readonly organizationId: string

    /**
     * Integration ID to update (required).
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateIntegration
     */
    readonly id: string

    /**
     * 
     * @type {UpdateIntegrationRequest}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateIntegration
     */
    readonly updateIntegrationRequest: UpdateIntegrationRequest
}

/**
 * Request parameters for integrationsAPIUpdateRepositories operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositories
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateRepositoriesRequest}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositories
     */
    readonly updateRepositoriesRequest: UpdateRepositoriesRequest
}

/**
 * Request parameters for integrationsAPIUpdateRepositoryDiscovery operation in IntegrationsAPIApi.
 * @export
 * @interface IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest
 */
export interface IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest {
    /**
     * The organization ID to which the integration belongs.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscovery
     */
    readonly organizationId: string

    /**
     * The ID of the integration.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscovery
     */
    readonly runbookIntegrationId: string

    /**
     * The ID of the repository.
     * @type {string}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscovery
     */
    readonly repositoryId: string

    /**
     * 
     * @type {UpdateRepositoryDiscoveryRequestRepositoryDiscovery}
     * @memberof IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscovery
     */
    readonly updateRepositoryDiscoveryRequestRepositoryDiscovery: UpdateRepositoryDiscoveryRequestRepositoryDiscovery
}

/**
 * IntegrationsAPIApi - object-oriented interface
 * @export
 * @class IntegrationsAPIApi
 * @extends {BaseAPI}
 */
export class IntegrationsAPIApi extends BaseAPI {
    /**
     * Adds integration to a runbook.
     * @summary Add an integration to a runbook.
     * @param {IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIAddIntegrationToRunbook(requestParameters: IntegrationsAPIApiIntegrationsAPIAddIntegrationToRunbookRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIAddIntegrationToRunbook(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.runbookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new integration for an organization.
     * @summary Create a new integration.
     * @param {IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPICreateIntegration(requestParameters: IntegrationsAPIApiIntegrationsAPICreateIntegrationRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPICreateIntegration(requestParameters.integrationOrganizationId, requestParameters.createIntegrationRequestIntegration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new repositories for an integration.  Deprecated: Use SyncIntegrationRepositories instead.
     * @summary Create new repositories for an integration.
     * @param {IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPICreateIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPICreateIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPICreateIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.createIntegrationRepositoriesRequestIntegrationRepositories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create discovery results for a repository.
     * @summary Create discovery results for a repository.
     * @param {IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPICreateRepositoryDiscovery(requestParameters: IntegrationsAPIApiIntegrationsAPICreateRepositoryDiscoveryRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPICreateRepositoryDiscovery(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.createRepositoryDiscoveryRequestRepositoryDiscovery, requestParameters.orgRepositoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes integration from a runbook.
     * @summary Deletes integration from a runbook.
     * @param {IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIDeleteIntegrationFromRunbook(requestParameters: IntegrationsAPIApiIntegrationsAPIDeleteIntegrationFromRunbookRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIDeleteIntegrationFromRunbook(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.runbookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization-scoped integration by ID.
     * @summary Delete organization-scoped integration by ID.
     * @param {IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIDeleteIntegrationOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIDeleteIntegrationOrganizationRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIDeleteIntegrationOrganization(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organization-scoped integration by ID.
     * @summary Get organization-scoped integration by ID.
     * @param {IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIGetIntegrationOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIGetIntegrationOrganizationRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIGetIntegrationOrganization(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List integration repositories.
     * @summary List integration repositories.
     * @param {IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIListIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIListIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIListIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.includeDisabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List integrations for runbooks for a particular organization.
     * @summary List integrations for runbooks.
     * @param {IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIListIntegrationsOrganization(requestParameters: IntegrationsAPIApiIntegrationsAPIListIntegrationsOrganizationRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIListIntegrationsOrganization(requestParameters.organizationId, requestParameters.includeClusterIntegrations, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all repositories for an organization
     * @summary List all repositories for an organization.
     * @param {IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIListOrganizationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIListOrganizationRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIListOrganizationRepositories(requestParameters.organizationId, requestParameters.integrationIds, requestParameters.includeDiscovery, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List repository discoveries with filtering.
     * @summary List repository discoveries with filtering.
     * @param {IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIListRepositoryDiscoveries(requestParameters: IntegrationsAPIApiIntegrationsAPIListRepositoryDiscoveriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIListRepositoryDiscoveries(requestParameters.organizationId, requestParameters.integrationIds, requestParameters.repositoryIds, requestParameters.workloadFilterNames, requestParameters.workloadFilterNamespaces, requestParameters.workloadFilterKinds, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record that a repository scan was skipped due to no changes.
     * @summary Record that a repository scan was skipped due to no changes.
     * @param {IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIRecordScanSkip(requestParameters: IntegrationsAPIApiIntegrationsAPIRecordScanSkipRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIRecordScanSkip(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.recordScanSkipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync repositories for an integration
     * @summary Sync repositories for an integration.
     * @param {IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPISyncIntegrationRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPISyncIntegrationRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPISyncIntegrationRepositories(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.syncIntegrationRepositoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateIntegration updates an integration\'s status fields.  Used by runbook operator to report integration health.
     * @summary Update an integration\'s status.
     * @param {IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIUpdateIntegration(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateIntegrationRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIUpdateIntegration(requestParameters.organizationId, requestParameters.id, requestParameters.updateIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update repositories discovery settings in bulk.
     * @summary Update repositories discovery settings.
     * @param {IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIUpdateRepositories(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIUpdateRepositories(requestParameters.organizationId, requestParameters.updateRepositoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update existing discovery results for a repository.
     * @summary Update discovery results for a repository.
     * @param {IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsAPIApi
     */
    public integrationsAPIUpdateRepositoryDiscovery(requestParameters: IntegrationsAPIApiIntegrationsAPIUpdateRepositoryDiscoveryRequest, options?: RawAxiosRequestConfig) {
        return IntegrationsAPIApiFp(this.configuration).integrationsAPIUpdateRepositoryDiscovery(requestParameters.organizationId, requestParameters.runbookIntegrationId, requestParameters.repositoryId, requestParameters.updateRepositoryDiscoveryRequestRepositoryDiscovery, options).then((request) => request(this.axios, this.basePath));
    }
}

